import { handleResponse, handleError } from "./apiUtils";
const baseUrl = process.env.REACT_APP_API_SERVER_URL + "/api/network";
const baseUrlProfile = process.env.REACT_APP_API_SERVER_URL + "/api/profile";

export function getNetwork(accessToken) {
  return fetch(baseUrl, {
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getAttendingNetwork(accessToken, eventId) {
  console.log("Get Attending Network for event with id: ", eventId);
  return fetch(baseUrl + "?eventid=" + eventId, {
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function addToNetwork(accessToken, profileId) {
  return fetch(baseUrl, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify({ profileId: profileId })
  })
    .then(handleResponse)
    .catch(handleError);
}

export function removeFromNetwork(accessToken, profileId) {
  return fetch(baseUrl, {
    method: "DELETE",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify({ profileId: profileId })
  })
    .then(handleResponse)
    .catch(handleError);
}

//what happens with no searchInput or no city input?
export function searchProfiles(accessToken, searchInput, selectedCity) {
  console.log(
    "searchProfiles with input: " + searchInput + "and city: " + selectedCity
  );
  return fetch(
    baseUrlProfile + "/search?input=" + searchInput + "&city=" + selectedCity,
    {
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + accessToken
      }
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
